<template>
  <div>
    <slist-header v-transition></slist-header>
    <slist-icons :ilist="subCategoryList" v-transition></slist-icons>
    <slist-lastest :list="latestList" v-transition></slist-lastest>
  </div>
</template>

<script>
import SlistHeader from './components/Header'
import SlistIcons from './components/Icons'
import SlistLastest from './components/Lastest'
export default {
  name: 'Home',
  components: {
    SlistHeader,
    SlistIcons,
    SlistLastest
  },
  data () {
    return {
      latestList: [],
      subCategoryList: []
    }
  },
  methods: {
    getListInfo () {
      this.axios.get('/ApiSubCategory/GetSynthetic', {
        params: {
          id: this.$route.params.id
        }// 获取id值并发送给后端
      }).then(this.getListInfoSucc)
        .catch(this.getListInfoFail)
    },
    getListInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.subCategoryList = JSON.parse(data.subCategoryList)
      }
    },
    getListInfoFail () {
      alert('获取数据失败')
    }
  },
  mounted () {
    this.getListInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/list/Slist.vue